import React, { useContext } from 'react'
import { Link } from 'gatsby'
import styled, { keyframes } from 'styled-components'

import DesktopCategoryItem from './desktop/CategoryItem'
import MobileCategoryItem from './mobile/CategoryItem'
import Image from '../../atoms/Image'
import { GlobalMenuContext } from '../../contexts/GlobalMenuContext'
import { MysqlCategoriesEdge } from '../../graphqlTypes'

const Logo = styled.div`
  width: 160px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    width: 260px;
  }
`

const Container = styled.header`
  align-items: center;
  background: ${({ theme }) => theme.palette.background.main};
  border-top: ${({ theme }) => `3px solid ${theme.palette.primary.main}`};
  border-bottom: 1px solid ${({ theme }) => theme.palette.border.light};
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding: 10px 15px 10px 5px;
  position: sticky;
  top: 0;
  width: 100%;
  height: 68px;
  z-index: 9000;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    border-top: ${({ theme }) => `5px solid ${theme.palette.primary.main}`};
    border-bottom: 0;
    padding: 20px 180px 15px;
    position: relative;
    height: auto;
  }
`

const LogoLink = styled(Link)`
  display: block;
  text-decoration: none;
`

const Right = styled.div`
  flex: 1;
  margin-right: auto;
  text-align: right;
`

const DesktopCategoryList = styled.ul`
  display: none;
  list-style: none;
  padding: 0;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    display: block;
  }
`

const toggleCategoryList = keyframes`
  0% { right: -200px; }
  100% { right: 0; }
`

const MobileCategoryList = styled.ul<{ open?: boolean }>`
  animation: ${toggleCategoryList} 0.3s ease-out;
  display: ${({ open }) => (open ? 'block' : 'none')};
  list-style: none;
  margin: 14px 0 0;
  padding: 0 0 80px 0;
  background: ${({ theme }) => theme.palette.background.main};
  position: absolute;
  overflow-y: scroll;
  right: 0;
  width: 200px;
  height: calc(100vh - 68px);
  z-index: 9000;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    display: none;
  }
`

const HamburgerButton = styled.button`
  vertical-align: middle;
  width: 35px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    display: none;
  }
`

export type LogoVariant = 'h1' | 'p'

export default function Header({ logoVariant, menu }: { logoVariant?: LogoVariant; menu: MysqlCategoriesEdge[] }) {
  const openGlobalMenu = useContext(GlobalMenuContext)

  return (
    <Container>
      <Logo as={logoVariant}>
        <LogoLink to="/">
          <Image alt="ママリ口コミ大賞" filename="logo.png" />
        </LogoLink>
      </Logo>
      <Right>
        <nav>
          {/* Desktop */}
          <DesktopCategoryList>
            {menu.map(({ node }) => (
              <DesktopCategoryItem category={node} key={node.id} />
            ))}
          </DesktopCategoryList>
          {/* Mobile */}
          <HamburgerButton onClick={() => openGlobalMenu.dispatch({ type: 'toggleGlobalMenu' })}>
            <Image filename="hamburger.png" />
          </HamburgerButton>
          <MobileCategoryList open={openGlobalMenu.state}>
            {menu.map(({ node }) => (
              <MobileCategoryItem category={node} key={node.id} />
            ))}
          </MobileCategoryList>
        </nav>
      </Right>
    </Container>
  )
}
